import {injectable} from "inversify";
import {ShopService} from "@/services/shop-service";
import {TabbedPanel} from "@/scenes.ui/tabbed-panel";
import {Tr} from "@/i18n/i18n";
import ShopStore from "@/store/shop";
import {Player} from "@/store/player/types";
import PlayerStore from "@/store/player";
import {HeroExchangeOptions, PortalShopDto, ShopCreature} from "@/store/shop/types";
import {ShopCreaturePanel} from "@/scenes.ui/shop-creature-panel";
import {CreatureUtils} from "@/utils/creature-utils";
import {HeroShopService} from "@/services/hero-shop-service";
import Container = Phaser.GameObjects.Container;
import SoundUtils from "@/utils/sound-utils";
import {NewCreaturePanel} from "@/scenes.ui/new-creature-panel";
import {PortalHeroPanel} from "@/scenes.ui/portal-hero-panel";
import {ValuteHeroPanel} from "@/scenes.ui/valute-hero-panel";
import ShopUtils from "@/utils/shop-utils";
import {IntegrationUtils} from "@/utils/integration-utils";

@injectable()
export class PortalShopService extends ShopService {

    protected createTabbedPanel(): TabbedPanel {
        let self = this;
        return new TabbedPanel(this.scene!, this.canvas!, Tr('port.shp'), ['sur', 'heroes'],
            [Tr('sht.sur'), Tr('sht.port')], [true, true], this.selectSound, (tabId: string) => {
                if (tabId === 'sur') {
                    this.populateSurTab();
                } else if (tabId === 'heroes') {
                    this.populatePortalTab();
                }
            }, () => {}, () => self.closeCallback());
    }

    protected populatePortalTab(): void {
        let self = this;

        let player = PlayerStore.getPlayer()!;
        this.setupHeroAgitations(player);

        ShopStore.fetchPortalShopCreatures().then((ps: PortalShopDto) => {
            let panels: Container[] = [];
            let self = this;

            panels.push(...HeroShopService.getTopTextsByTabId(this.scene!, this.canvas!));

            let panelY = 0;
            ps.creatures.forEach(sc => {
                let classText = CreatureUtils.getClassName(sc.creature.warriorClass);
                if (!classText) {
                    return;
                }

                let myNSCount = sc.oldPrice;
                sc.oldPrice = sc.price;
                let scp = new PortalHeroPanel(this.scene!, 0, panelY, sc, self.statClickCallback,() => {
                    SoundUtils.play(self.awardSound);
                    ShopStore.buyCreaturePortal(sc.id).then(() => {
                        sc.creatures.forEach(c => {
                            new NewCreaturePanel(self.scene!, self.canvas!, c).open();
                        });
                    });
                }, ps.nsCount, ps.haveIds.includes(sc.id));

                panels.push(scp);
                panelY += ShopCreaturePanel.HEIGHT;
            });

            this.tabbedPanel.supplyChildren('heroes', panels);
        });
    }

    protected populateSurTab(): void {
        let self = this;

        let player = PlayerStore.getPlayer()!;
        this.setupHeroAgitations(player);

        ShopStore.fetchHeroExchangeOptions('sur_town').then((eo: HeroExchangeOptions) => {
            const shopCreatures: ShopCreature[] = eo.shopCreatures;
            let panels: Container[] = [];
            let self = this;

            panels.push(...HeroShopService.getTopTextsByTabId(this.scene!, this.canvas!));

            let panelY = 0;
            shopCreatures.forEach(sc => {
                let classText = CreatureUtils.getClassName(sc.creature.warriorClass);
                if (!classText) {
                    return;
                }

                let scp = new ValuteHeroPanel(this.scene!, 0, panelY, sc, self.statClickCallback,() => {
                    let bo = sc.bankOption;
                    ShopUtils.buy(undefined, self.awardSound, player.userSource,
                        self.paymentNotificationService, self.iapService, self.paymentChangeService, bo, IntegrationUtils.isExternalUser());
                });

                panels.push(scp);
                panelY += ShopCreaturePanel.HEIGHT;
            });

            this.tabbedPanel.supplyChildren('sur', panels);
        });
    }

    protected setupHeroAgitations(player: Player) {
        this.tabbedPanel.setAgitationText(Tr('ns.f'));
    }
}
